import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FaPhone } from 'react-icons/fa';
import { IoIosArrowUp, IoMdCall } from "react-icons/io";
import { IoLogoWhatsapp } from "react-icons/io";
import './App.css';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Navbar from './components/navbar/Navbar';
import AdminProducts from './components/admin/AdminProducts';
import AdminDashboard from './components/admin/AdminDashboard';

import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Footer from './components/footer/Footer';
import FeedbackForm from './components/feedback/FeedbackForm';
import Login from './components/authentications/Login';
import Register from './components/authentications/Register';
import ResetPassword from './components/authentications/ResetPassword';
import UserDashboard from './components/user/UserDashboard';
import UserProfile from './components/user/UserProfile';
import UserChatComponent from './components/user/UserChatComponent';
import SingleAdminProduct from './components/admin/SingleAdminProduct';
import ChatComponent from './components/admin/ChatComponent';
import Category from './components/products/Category';
import SecondaryProducts from './components/products/SecondaryProducts';
import SingleProduct from './components/products/SingleProduct';

import SingleSearchProduct from './components/products/SingleSearchProduct';
import Contact from './components/Contact';
import Service from './components/Service';
import ScrollToTop from './components/ScrollToTop';
import TermsAndConditions from './components/TandC';
import AosAnimation from './components/AosAnimation';


const App = () => {
  const [showScrollButton, setShowScrollButton] = useState(false); 

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <AuthProvider>
      
          <Router>
           
           {/* Ensure pages start at the top when navigating */}
           <ScrollToTop /> 
           <AosAnimation />

            {/* Scroll to Top Button */}
            {showScrollButton && (
             <button className="scroll-to-top" onClick={scrollToTop}><IoIosArrowUp /></button>
           )}
 
            <Navbar /> 

            <div>
               <a href='tel: +234-802-387-9629'>
                 <div className='side-box'>
                    <IoMdCall/>
                 </div> 
                </a>
                <a href="https://wa.me/2348023879629?text=Hi,%20I%20want%20to%20print" target="_blank" rel="noopener noreferrer">
                 <div className="side-box2">
                   <IoLogoWhatsapp />
                 </div>
                </a>

            </div>

            <Routes>
              {/* Public Routes */}
              <Route path="/" exact element={<Home />} />
              <Route path="/category/:category" element={<Category />} />
              <Route path="/products/:productName" element={<SecondaryProducts />} />
              <Route path="/products/:productName/:productId" element={<SingleProduct />} />
              <Route path="/search/:nameOrCategory" element={<SingleSearchProduct />} />
              

              <Route path='/contact' element={ <Contact/>} />
              <Route path='/term-condition' element={ <TermsAndConditions/>} />
              <Route path='/service' element={ <Service/>} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/products" element={<AdminProducts />} />
              <Route path="/product/:productId" element={<SingleAdminProduct />} />

                            {/* Auth Routes */}
                            <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Protected User Routes */}
              <Route path="/user-dashboard/*" element={<ProtectedRoute element={<UserDashboard />} />}>
                <Route path="user-profile" element={<UserProfile />} />
                <Route path="user-chat" element={<UserChatComponent/>} />
              </Route>

              <Route path="chat" element={<ChatComponent />} />
             

              {/* Protected Admin Routes */}
              <Route path="/admin-dashboard" element={
              <ProtectedRoute element={<AdminDashboard />} adminOnly />
            } />
           

        
              <Route path="/feedback" element={<FeedbackForm />} />
              
             
            </Routes>
          
            <Footer />
          
          </Router>
      
    </AuthProvider>
  );
};

export default App;